<template>
  <div class="mb-10">
    <!-- page {{ currentModule }} -->
    <ed-images v-if="currentModule == 'educational-images'"></ed-images>
    <billing-protocols
      v-else-if="currentModule == 'billing-protocols'"
    ></billing-protocols>
    <cl-products v-else-if="currentModule == 'cl-products'"></cl-products>
    <clinical-references v-else
      ><!-- ="page == 'tables'" --></clinical-references
    >
    <!-- <div v-else>{{ page }}</div> -->
  </div>
</template>

<script>
import CurrentModuleMixin from "@/assets/js/CurrentModuleMixin";
export default {
  name: "ReferencesHome",
  components: {
    ClinicalReferences: () =>
      import("@/components/referencesStuff/ClinicalReferences"),
    BillingProtocols: () =>
      import("@/components/referencesStuff/BillingProtocols"),
    EdImages: () => import("@/components/referencesStuff/EdImages"),
    ClProducts: () => import("@/components/referencesStuff/ClProducts"),
  },
  mixins: [
    CurrentModuleMixin,
    // FiltersMixin
  ],

  props: {},
  data: function () {
    return {
      page: null,
    };
  },
  methods: {},
  computed: {},
  mounted() {
    // this.page = this.$route.params?.page?.toLowerCase();
  },
};
</script>

<style scoped></style>
